import React, { useState, useEffect } from 'react';
import './App.css';
import './components/styles/sections.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import CaseStudies from './components/CaseStudies';
import Process from './components/Process';
import CTA from './components/CTA';
import AppointmentPage from './components/AppointmentPage';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminDashboard from './components/AdminDashboard';
// ... AdminPanel is used inside AdminDashboard; ProtectedRoute not needed for consolidated dashboard

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      // Update UI to notify the user they can install the PWA
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      // Show the install prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        // Clear the deferred prompt
        setDeferredPrompt(null);
        setShowInstallButton(false);
      });
    }
  };

  return (
    <BrowserRouter>
      <div className="App">
        {showInstallButton && (
          <div style={{
            position: 'fixed',
            top: '10px',
            right: '10px',
            background: '#000',
            color: '#fff',
            padding: '10px',
            borderRadius: '5px',
            zIndex: 1000
          }}>
            <button onClick={handleInstallClick} style={{
              background: '#fff',
              color: '#000',
              border: 'none',
              padding: '5px 10px',
              cursor: 'pointer'
            }}>
              Install App
            </button>
          </div>
        )}
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<>
              <Hero />
              <About />
              <Services />
              <Testimonials />
              <CaseStudies />
              <Process />
              <CTA />
              <FAQ />
              <Blog />
              <Contact />
            </>} />
            <Route path="/appointment" element={<AppointmentPage />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
